import { render, staticRenderFns } from "./academic_questionType_management.vue?vue&type=template&id=22af9c74&scoped=true&"
import script from "./academic_questionType_management.vue?vue&type=script&lang=js&"
export * from "./academic_questionType_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_questionType_management.vue?vue&type=style&index=0&id=22af9c74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af9c74",
  null
  
)

export default component.exports